import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "3f9bda00-e7b5-4dda-9353-1c749c04470c"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter3f9bda00E7b54dda93531c749c04470c(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter3f9bda00E7b54dda93531c749c04470c footer`}>
      {props["links"] || <Navigation className="LinksC6a9d897D2a44a18A8533b692f773ef3" parentTag={buildClassName("LinksC6a9d897D2a44a18A8533b692f773ef3", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo4472468a374347bb9f30281b67a8bfaa" parentTag={buildClassName("Logo4472468a374347bb9f30281b67a8bfaa", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightBcbe12fdB31e47188e82Ad69578a1d92" parentTag={buildClassName("CopyrightBcbe12fdB31e47188e82Ad69578a1d92", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow9620ada5F94643da96440d335c066685" parentTag={buildClassName("Groupflow9620ada5F94643da96440d335c066685", parentTag)} {...props} />}
    </footer>
  );
}

// id: "4472468a-3743-47bb-9f30-281b67a8bfaa"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "3f9bda00-e7b5-4dda-9353-1c749c04470c"
export function Logo4472468a374347bb9f30281b67a8bfaa(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo4472468a374347bb9f30281b67a8bfaa" parentTag={buildClassName("Logo4472468a374347bb9f30281b67a8bfaa", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "bcbe12fd-b31e-4718-8e82-ad69578a1d92"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "3f9bda00-e7b5-4dda-9353-1c749c04470c"
export function CopyrightBcbe12fdB31e47188e82Ad69578a1d92(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightBcbe12fdB31e47188e82Ad69578a1d92" parentTag={buildClassName("CopyrightBcbe12fdB31e47188e82Ad69578a1d92", parentTag)} {...props} />
  );
}

// id: "c6a9d897-d2a4-4a18-a853-3b692f773ef3"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "3f9bda00-e7b5-4dda-9353-1c749c04470c"
export function LinksC6a9d897D2a44a18A8533b692f773ef3(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksC6a9d897D2a44a18A8533b692f773ef3" parentTag={buildClassName("LinksC6a9d897D2a44a18A8533b692f773ef3", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "9620ada5-f946-43da-9644-0d335c066685"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "3f9bda00-e7b5-4dda-9353-1c749c04470c"
export function Groupflow9620ada5F94643da96440d335c066685(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow9620ada5F94643da96440d335c066685" parentTag={buildClassName("Groupflow9620ada5F94643da96440d335c066685", parentTag)} {...props} />
  );
}

// id: "2ef7a3df-ea17-40ed-bee7-7c162c520f10"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "4472468a-3743-47bb-9f30-281b67a8bfaa"
export const LogoType2ef7a3dfEa1740edBee77c162c520f10 = "FOOTER";

// id: "7a785ab4-4f2d-4ab1-a564-917c109793f6"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "c6a9d897-d2a4-4a18-a853-3b692f773ef3"
export const NavMenuSlug7a785ab44f2d4ab1A564917c109793f6 = "footer-nav";

// id: "fdbe832a-3cb1-4828-85ab-3838f67fda17"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4472468a-3743-47bb-9f30-281b67a8bfaa"
export const ContentSlugFdbe832a3cb1482885ab3838f67fda17 = "footer-logo";

const Components = {
  DefaultFooter3f9bda00E7b54dda93531c749c04470c,
  Logo4472468a374347bb9f30281b67a8bfaa,
  CopyrightBcbe12fdB31e47188e82Ad69578a1d92,
  LinksC6a9d897D2a44a18A8533b692f773ef3,
  Groupflow9620ada5F94643da96440d335c066685,
  LogoType2ef7a3dfEa1740edBee77c162c520f10,
  NavMenuSlug7a785ab44f2d4ab1A564917c109793f6,
  ContentSlugFdbe832a3cb1482885ab3838f67fda17
}

export default Components;